import { Typography, styled } from '@mui/material'
import { DownDoubleArrow } from '$common/icons/down-double-arrow'
import { t } from '$i18n'
import { PosInBlock } from '../../react-hooks'
import { getPadding } from '../message-wrapper/message-wrapper'

interface StyledListItemProps {
  posInBlock: PosInBlock
}
const StyledListItem = styled('li', {
  shouldForwardProp: prop => prop !== 'posInBlock',
})<StyledListItemProps>`
  display: flex;
  width: 100%;
  padding: ${({ posInBlock }) => getPadding(posInBlock, true, false, false)};

  margin: 0;
  &:first-of-type {
    margin-top: 6px;
  }
  &:last-child {
    margin-bottom: 6px;
  }
`

const Container = styled('div')`
  display: flex;
  width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;

  position: relative;
  background-color: #7e8996cc;
`

const StyledDownArrow = styled(DownDoubleArrow)`
  position: absolute;
  right: 12px;
  top: 3px;
`

export function UnseenSeparator({ posInBlock }: { posInBlock: PosInBlock }) {
  return (
    <StyledListItem id="unseen-separator" posInBlock={posInBlock}>
      <Container>
        <StyledDownArrow />
        <Typography color="white" variant="subtitle4">
          {t('message.unreadMessages')}
        </Typography>
      </Container>
    </StyledListItem>
  )
}
